import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ orderStatuses, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (orderStatuses.loading) {
      return "is Loading";
    }
    if (isEmpty(orderStatuses.data)) {
      return <p className="is-size-2 has-text-centered has-text-grey">Found Nothing</p>;
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {orderStatuses.data.map(orderStatus => (
            <tr key={orderStatus.id}>
              <td>
                <a>{orderStatus.id}</a>
              </td>
              <td>{orderStatus.status}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link to={`/order-status/${orderStatus.id}/edit`} className="button  is-link is-small">
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(orderStatus.id)}
                    to={`/order-status/${orderStatus.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/OrderStatus/Index/Table.js